import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styles from './styles'

const NotFoundPage = () => {
  const { t } = useTranslation()

  useEffect(() => {
    document.body.style.overflowY = 'hidden'
    return () => {
      document.body.style.overflowY = null
    }
  }, [])

  return (
    <Styles.Container>
      <Styles.InfoContainer>
        <img src="/logos/reveni_logo_white.svg" />
        <hr />
        <h1>404 · {t('Página no encontrada')}</h1>
        <p>{t('No podemos encontrar la pagina solicitada. ¡Lo sentimos!')}</p>
        <a href="https://reveni.com">{t('Visita nuestra página')}</a>
      </Styles.InfoContainer>
    </Styles.Container>
  )
}

export default NotFoundPage
